module.exports = __webpack_public_path__ + "static/media/heart5.9d580266.png";